import * as React from 'react'
import { getMonthShortNameByNumber } from 'app/common/dateHelper'

export type CalendarMonthsProps = {
  height: number
  width: number
  translate: (text: any) => any
}

const months = Array.from({ length: 12 }, (_, i) => i)

export const CalendarMonths: React.FC<CalendarMonthsProps> = ({
  height,
  width,
  translate,
}) => {
  return (
    <div className="tw-flex tw-flex-col">
      {months.map((month, index) => (
        <div
          key={index}
          className={`tw-flex tw-items-start tw-justify-center tw-border-b tw-border-r tw-border-base-300 tw-bg-white tw-p-1.5 ${index === 0 ? 'tw-border-t' : ''} `}
          style={{
            width,
            height,
          }}
        >
          <span className="tw-text-xs tw-text-content-base">
            {translate(getMonthShortNameByNumber(month))}
          </span>
        </div>
      ))}
    </div>
  )
}
